module.exports = __webpack_public_path__ + "img/47.210235bd.png";